import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hiddenInput", "results", "doctorSelect"]

  connect() {
    this.searchTimeout = null
    // Agregar listener para cerrar resultados cuando se hace click fuera
    document.addEventListener('click', this.handleClickOutside.bind(this))
    
    // Cargar el mapeo de doctores desde el data attribute
    this.loadDoctorsMap()
  }

  loadDoctorsMap() {
    // Inicializar siempre como array vacío
    this.doctorsMap = []
    
    // Solo cargar el mapeo si hay doctor select (cuando current_user no es doctor)
    if (this.hasDoctorSelectTarget) {
      const doctorsData = this.doctorSelectTarget.dataset.doctors
      if (doctorsData) {
        try {
          this.doctorsMap = JSON.parse(doctorsData)
        } catch (e) {
          console.error('Error parsing doctors data:', e)
        }
      } else {
        console.warn('No doctors data found in data attribute')
      }
    }
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }

  handleClickOutside(event) {
    // Verificar si el click fue fuera del input y de los resultados
    if (!this.element.contains(event.target)) {
      this.closeResults()
    }
  }

  onDoctorChange(event) {
    // Limpiar la selección de paciente cuando cambia el doctor
    this.inputTarget.value = ''
    this.hiddenInputTarget.value = ''
    this.closeResults()
    
    // Cargar automáticamente la lista de pacientes del doctor seleccionado
    this.performSearch('')
  }

  search(event) {
    const query = event.target.value.trim()
    
    // Limpiar timeout anterior
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }

    // Si la consulta está vacía, mostrar todos los pacientes
    if (query.length === 0) {
      this.performSearch('')
      return
    }

    // Esperar 300ms antes de hacer la búsqueda
    this.searchTimeout = setTimeout(() => {
      this.performSearch(query)
    }, 300)
  }

  focus(event) {
    const query = event.target.value.trim()
    // Solo hacer búsqueda si hay texto (mínimo 2 caracteres)
    if (query.length >= 2) {
      this.performSearch(query)
    }
  }

  performSearch(query) {
    // Obtener el doctor seleccionado o el current user si es doctor
    let doctorEmail = ''
    
    if (this.hasDoctorSelectTarget) {
      // Si hay doctor select, obtener el email del doctor seleccionado
      const doctorSelect = this.doctorSelectTarget
      const selectedOption = doctorSelect.options[doctorSelect.selectedIndex]
      if (selectedOption && selectedOption.value) {
        // El value del option es el ID, necesitamos obtener el email
        const doctorId = selectedOption.value
        const doctor = this.doctorsMap.find(d => d.id == doctorId)
        if (doctor) {
          doctorEmail = doctor.email
        } else {
          console.warn(`Doctor with ID ${doctorId} not found in doctorsMap`)
        }
      }
    } else {
      // Si no hay doctor select, el current user es doctor
      const currentUserEmail = document.querySelector('input[name="current_user_email"]')?.value
      if (currentUserEmail) {
        doctorEmail = currentUserEmail
      }
    }

    // Si no hay doctor seleccionado, no hacer la búsqueda
    if (!doctorEmail) {
      this.resultsTarget.innerHTML = '<div class="p-2 text-muted"><i class="fas fa-info-circle mr-2"></i>Seleccione un doctor primero</div>'
      this.resultsTarget.classList.remove('d-none')
      return
    }

    // Construir la URL con el doctor y la query
    let url = `/appointments/search_patients?query=${encodeURIComponent(query)}`
    if (doctorEmail) {
      url += `&doctor_email=${encodeURIComponent(doctorEmail)}`
    }
    
    fetch(url, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(html => {
      this.resultsTarget.innerHTML = html
      this.resultsTarget.classList.remove('d-none')
      
      // Agregar event listeners a los resultados después de cargar el HTML
      this.addResultListeners()
    })
    .catch(error => {
      console.error('Error searching patients:', error)
    })
  }

  addResultListeners() {
    const resultItems = document.querySelectorAll('.patient-search-result')
    resultItems.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault()
        const patientId = item.dataset.patientId
        const patientName = item.dataset.patientName
        
        this.selectPatient(patientId, patientName)
      })
    })
  }

  selectPatient(patientId, patientName) {
    this.inputTarget.value = patientName
    this.hiddenInputTarget.value = patientId
    this.closeResults()
  }

  closeResults() {
    if (this.hasResultsTarget) {
      this.resultsTarget.classList.add("d-none")
    }
  }
} 